var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-06-28
 * @brief SEI 운영관리 -Tree 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loadingBoxState } from "../../../recoil/menuState";
import { reLoad, reLoadPage, userInfoLoginState } from "../../../recoil/userState";
// utils
import dayjs from "dayjs";
import { adminApprovalState, adminTypeState, alertState, curAdminTreeState, mainState, } from "../../../recoil/assessmentState";
import { langId } from "../../../recoil/langState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
import EhpPostCode from "../../common/postcode/EhpPostCode";
// component
function OperationManagementTree(props) {
    const navigate = useNavigate();
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [recoilApproval, setRecoilApproval] = useRecoilState(adminApprovalState);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const [recoilState, setRecoilState] = useRecoilState(mainState);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop, setWorkMode, onClickTab, isMobile } = props;
    //
    const [treeItem, setTreeItem] = useState([]);
    const [toogle, setToogle] = useState(false);
    const [popreset, setPopreset] = useState(false);
    const [zoneAddress, setZoneAddress] = useState("");
    const [popReset, setPopRest] = useState(false);
    const [resetPop, setResetPop] = useState(false);
    const [resetRoomPop, setResetRoomPop] = useState(false);
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    useEffect(() => {
        // SuperUser 회사 사업장 신규 등록
        handleOpenPop("pop-add-company", _jsx(CompanyAddPop, { setIsPopupPostCode: setIsPopupPostCode, setZoneAddress: setZoneAddress, zoneAddress: zoneAddress, popReset: popReset, setPopRest: setPopRest, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.신규등록") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-add-company") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        // 상세 사업장 등록
        handleOpenPop("pop-add-detail", _jsx(SubZoneAddPop, { zoneAddress: zoneAddress, setZoneAddress: setZoneAddress, setIsPopupPostCode: setIsPopupPostCode, resetPop: resetPop, setResetPop: setResetPop, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.신규추가") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-add-detail") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        //분전소 등록
        handleOpenPop("pop-add-detail2", _jsx(RoomAddPop, { resetRoomPop: resetRoomPop, setResetRoomPop: setResetRoomPop, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.신규추가") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-add-detail2") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        //설비 등록
        handleOpenPop("pop-add-info2", _jsx(DeviceAddPop, { popreset: popreset, setPopreset: setPopreset, onClickTab: onClickTab, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.추가") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-add-info2") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        //
        handleOpenPop("pop-postcode", _jsx(EhpPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: setZoneAddress }));
    }, [zoneAddress, resetPop, resetRoomPop, popreset, isPopupPostCode]);
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
        setPopreset(true);
    }
    function Close(id) {
        setResetPop(true);
        setPopRest(true);
        setResetRoomPop(true);
        CUTIL.jsclose_Popup(id);
    }
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        // appPath: `/product/usertree?search=${treeSearchText}`,
        appPath: `/product/usertree`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: reloadPages + langIds.toString(),
    });
    let defTreeData = null;
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data /* !isLoading */) {
            if (data.codeNum == CONST.API_200) {
                let treeItem = data.body.filter((non, idx) => non.zone);
                let zoneCurr = null;
                let zoneCheck = treeItem.every((i) => i.zone.length == 0);
                if (treeItem.length > 0 && !zoneCheck) {
                    if (!recoilTree.company.companyId) {
                        let curComapy = treeItem.filter((item) => item.companyId == recoilState.companyId).length > 0
                            ? treeItem.filter((item) => item.companyId == recoilState.companyId)[0]
                            : treeItem[0];
                        let zoneItem = curComapy && curComapy.zone && curComapy.zone;
                        let curZone = zoneItem.filter((item) => item.zoneId == recoilState.zoneId).length > 0
                            ? zoneItem.filter((item) => item.zoneId == recoilState.zoneId)[0]
                            : zoneItem[0];
                        defTreeData = {
                            company: { companyId: curComapy.companyId, companyName: curComapy.companyName },
                            zone: { zoneId: curZone.zoneId, zoneName: curZone.zoneName },
                            subZone: { subZoneId: "", subZoneName: "" },
                            room: { roomId: "", roomName: "" },
                        };
                        zoneCurr = curZone;
                        if (curZone.approval <= 0) {
                            setRecoilApproval({
                                approval: curZone.approval,
                                deniedReason: curZone.deniedReason,
                            });
                        }
                        else {
                            setRecoilApproval({
                                approval: curZone.approval,
                                deniedReason: "",
                            });
                        }
                        setRecoilState({
                            companyId: curComapy.companyId,
                            zoneId: curZone.zoneId,
                        });
                        setRecoilTree(defTreeData);
                        if (recoilState.companyId &&
                            treeItem.filter((item) => item.companyId == recoilState.companyId).length <= 0) {
                            setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.해당회사사업장정보없음") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                    setTreeItem(data.body);
                }
                else if (zoneCheck) {
                    return null;
                }
                else {
                    navigate(CONST.URL_NOT_FOUND);
                }
            }
        }
    }, [data, reloadPages, langIds]);
    useEffect(() => {
        if (treeItem.length > 0) {
            if (reloadPages) {
                const spgId = document.getElementById(recoilTree.zone.zoneId);
                spgId.scrollIntoView({ block: "center" }); // 검색된 tree의 id
                setReloadPages(false);
            }
            else {
                CUTIL.selectFoucs(recoilTree.zone.zoneId, { type: "c" });
            }
        }
    }, [treeItem]);
    function Toogle(e) {
        if (!toogle) {
            setToogle(true);
        }
        else {
            setToogle(false);
        }
    }
    function CompanyAdd(e) {
        /*  if (userInfo.role == CONST.USERROLE_ADMIN) {
          // Admin -> 사업장 관리 이동
          if (isMobile) {
    
            setAlerts({
              ...alerts,
              type: CONST.TYPE_NONE,
              divTag: "WEB 포털 사이트에서 사용 가능한 기능입니다.",
            });
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
          } else {
            setRecoilNoneUrlInfo(false);
            setRecoilUrlInfo(CONST.URL_SITEMANAGEMENT);
            navigate(CONST.URL_SITEMANAGEMENT);
          }
    
        } else */ if (userInfo.role == CONST.USERROLE_SUPER || userInfo.role == CONST.USERROLE_ADMIN) {
            // SuperUser -> 신규 등록 팝업
            CUTIL.jsopen_Popup(e);
            setZoneAddress("");
        }
        else {
            // 그외 화면 추가 이동
            setWorkMode("CREATE");
            setRecoilTree({
                company: { companyId: "", companyName: "" },
                zone: { zoneId: "", zoneName: "" },
                subZone: { subZoneId: "", subZoneName: "" },
                room: { roomId: "", roomName: "" },
            });
            setRecoilApproval({
                approval: -1,
                deniedReason: "",
            });
        }
        setToogle(false);
    }
    // 트리 이외 다른곳 닫기
    return (_jsxs(_Fragment, { children: [recoilTree && (_jsx("div", Object.assign({ className: `treebar__toggleBtn ${toogle ? "active" : ""}`, onClick: (e) => Toogle(e) }, { children: _jsx("p", { children: recoilTree.company.companyId &&
                        recoilTree.company.companyName +
                            recoilTree.zone.zoneName +
                            recoilTree.subZone.subZoneName +
                            recoilTree.room.roomName }) }))), treeItem && (_jsx("div", Object.assign({ className: `box treebar pushy-menutype navy ${toogle ? "active" : ""}` }, { children: _jsxs("div", Object.assign({ className: "lnb" }, { children: [_jsx("button", Object.assign({ type: "button", className: "add__item js-open", "data-pop": "pop-add-company", onClick: (e) => CompanyAdd(e) }, { children: userInfo.role == CONST.USERROLE_USER || userInfo.role == CONST.USERROLE_ENGINEER ? (_jsx("span", { children: t("라벨.회사/사업장추가하기") })) : (_jsx("span", { children: t("라벨.사업장추가") })) })), _jsx("ul", Object.assign({ className: "lnb-depth1" }, { children: treeItem.map((company, idx) => (_jsx(ZonTree, { company: company, zone: company.zone, setToogle: setToogle, setWorkMode: setWorkMode, setZoneAddress: setZoneAddress, onClickTab: onClickTab, isMobile: isMobile }, `comp_${idx.toString()}`))) }))] })) })))] }));
}
export default OperationManagementTree;
function ZonTree(props) {
    const t = useTrans();
    //recoil
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const setRecoilType = useSetRecoilState(adminTypeState);
    const [recoilApproval, setRecoilApproval] = useRecoilState(adminApprovalState);
    const setRecoilState = useSetRecoilState(mainState);
    // porps
    const { company, zone, setToogle, setWorkMode, setZoneAddress, onClickTab, isMobile } = props;
    function ZoneClick(item) {
        setRecoilTree(Object.assign(Object.assign({}, recoilTree), { company: { companyId: company.companyId, companyName: company.companyName }, zone: { zoneId: item.zoneId, zoneName: item.zoneName }, subZone: { subZoneId: "", subZoneName: "" }, room: { roomId: "", roomName: "" } }));
        let subzone_class = document.querySelector(".szadd");
        setRecoilApproval({
            approval: item.approval,
            deniedReason: item.deniedReason ? item.deniedReason : "",
        });
        setRecoilState({
            companyId: company.companyId,
            zoneId: item.zoneId,
        });
        setWorkMode("READ");
        setRecoilType("zone");
        onClickTab("SITE");
        /* if (item.approval !== 2) {
          onClickTab("SITE")
        } else if (recoilTree.zone.zoneId !== item.zoneId) {
          onClickTab("SITE")
        } else if (subzone_class) {
          onClickTab("SITE")
        } */
        //
        setToogle(false);
        let zone_class = document.querySelector(".add");
    }
    function SubZonePop(e) {
        e.stopPropagation();
        CUTIL.jsopen_Popup(e);
        setZoneAddress(null);
    }
    return (_jsx(_Fragment, { children: zone.map((item, idx) => (_jsxs("li", Object.assign({ className: `${item.approval == 2 && recoilTree.zone.zoneId == item.zoneId ? "active add" : ""} ${item.approval == 1 ? "requesting disabled" : item.approval <= 0 || item.approval >= 4 ? "requesting disabled delete" : ""}`, onClick: (e) => ZoneClick(item) }, { children: [_jsx("p", { children: _jsxs("a", Object.assign({ id: item.zoneId, href: "#", onClick: (e) => e.preventDefault() }, { children: [_jsx("span", { children: company.companyName }), _jsx("span", { children: item.zoneName })] })) }), _jsxs("ul", Object.assign({ className: "lnb-depth2" }, { children: [!item.hasOwnProperty("subZone") && (_jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "add__item js-open", "data-pop": "pop-add-detail", onClick: (e) => SubZonePop(e) }, { children: _jsx("span", { children: t("라벨.상세사업장추가") }) })) }, `nosubZone_`)), _jsx(SubZoneTree, { company: company, zone: item, subZone: item.subZone, setToogle: setToogle, setZoneAddress: setZoneAddress, onClickTab: onClickTab, isMobile: isMobile })] }))] }), "company_zone" + idx.toString()))) }));
}
function SubZoneTree(props) {
    const t = useTrans();
    //recoil
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const setRecoilType = useSetRecoilState(adminTypeState);
    //props
    const { isMobile, subZone, setToogle, setZoneAddress, onClickTab } = props;
    function SubZoneClick(e, item) {
        e.stopPropagation();
        var actTag = e.target.tagName === "A" ? e.currentTarget : e.target;
        setRecoilTree(Object.assign(Object.assign({}, recoilTree), { subZone: { subZoneId: item.subZoneId, subZoneName: item.subZoneName }, room: { roomId: "", roomName: "" } }));
        setRecoilType("subZone");
        setToogle(false);
        let zone_class = document.querySelector(".add");
        zone_class.classList.add("nobg");
        if (recoilTree.room.roomId) {
            let subzone_class = document.querySelector(".szadd");
            subzone_class.classList.remove("nobg");
        }
        onClickTab("SITE");
    }
    function SubZonePop(e) {
        e.stopPropagation();
        CUTIL.jsopen_Popup(e);
        setZoneAddress(null);
    }
    function RoomPop(e) {
        e.stopPropagation();
        CUTIL.jsopen_Popup(e);
    }
    return (_jsx(_Fragment, { children: subZone &&
            subZone.map((item, idx) => (_jsxs("li", Object.assign({ className: ` ${recoilTree && recoilTree.subZone.subZoneId == item.subZoneId ? "szadd active" : ""}`, onClick: (e) => SubZoneClick(e, item) }, { children: [idx == 0 && (_jsx("button", Object.assign({ type: "button", className: "add__item js-open", "data-pop": "pop-add-detail", onClick: (e) => SubZonePop(e) }, { children: _jsx("span", Object.assign({ "data-pop": "pop-add-detail" }, { children: t("라벨.상세사업장추가") })) }))), _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: item.subZoneName })), _jsxs("ul", Object.assign({ className: "lnb-depth3" }, { children: [!item.hasOwnProperty("room") && (_jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "add__item js-open", "data-pop": "pop-add-detail2", onClick: (e) => RoomPop(e) }, { children: _jsx("span", Object.assign({ "data-pop": "pop-add-detail2" }, { children: t("라벨.분전소추가") })) })) }, `noroom_`)), _jsx(RoomTree, { room: item.room, setToogle: setToogle, onClickTab: onClickTab, isMobile: isMobile })] }))] }), "subzoen_" + idx.toString()))) }));
}
function RoomTree(props) {
    const t = useTrans();
    //recoil
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const setRecoilType = useSetRecoilState(adminTypeState);
    //props
    const { room, setToogle, onClickTab, isMobile } = props;
    //
    const [open, setOpen] = useState(false);
    function RoomClick(e, item) {
        e.stopPropagation();
        setRecoilTree(Object.assign(Object.assign({}, recoilTree), { room: { roomId: item.roomId, roomName: item.roomName } }));
        if (e.target.classList.length <= 0) {
            setToogle(false);
        }
        setRecoilType("room");
        if (recoilTree.room.roomId !== item.roomId) {
            onClickTab("SITE");
        }
    }
    function BatchMoev(list) {
        setToogle(false);
        setOpen(false);
        onClickTab(list);
    }
    function RoomPop(e) {
        e.stopPropagation();
        CUTIL.jsopen_Popup(e);
    }
    function SpgPop(e) {
        CUTIL.jsopen_Popup(e);
        setToogle(false);
    }
    // 다른곳 닫기
    return (_jsx(_Fragment, { children: room &&
            room.map((item, idx) => (_jsxs("li", Object.assign({ className: `${recoilTree.room.roomId == item.roomId ? "active" : ""}`, onClick: (e) => RoomClick(e, item) }, { children: [idx === 0 && (_jsx("button", Object.assign({ type: "button", className: "add__item js-open", "data-pop": "pop-add-detail2", onClick: (e) => RoomPop(e) }, { children: _jsx("span", { children: t("라벨.분전소추가") }) }))), _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: item.roomName }) })), _jsx("ul", Object.assign({ className: "lnb-depth4" }, { children: _jsx("li", { children: recoilTree.room.roomId == item.roomId && (_jsxs(_Fragment, { children: [_jsx("button", Object.assign({ type: "button", className: `add__item btn-etc`, onClick: (e) => setOpen(!open) }, { children: _jsx("span", { children: t("라벨.설비추가") }) })), _jsxs("ul", Object.assign({ className: `popup-etc popup-etc_tree ${open ? "open" : ""}` }, { children: [_jsx("li", { children: _jsxs("button", Object.assign({ type: "button", className: "btn-add-g-s js-open", "data-pop": "pop-add-info2", onClick: (e) => SpgPop(e) }, { children: [" ", _jsx("span", { children: t("라벨.단일등록") })] })) }), _jsx("li", { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-all", onClick: (e) => BatchMoev("BATCH") }, { children: _jsx("span", { children: t("라벨.일괄등록") }) })) })] }))] })) }) }))] }), "room_" + idx.toString()))) }));
}
function CompanyAddPop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    //props
    const { zoneAddress, setIsPopupPostCode, popReset, setPopRest, setZoneAddress } = props;
    const [zoneName, setZoneName] = useState("");
    const [memo, setMemo] = useState("");
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        if (popReset) {
            Close("pop-add-company");
        }
        if (zoneAddress) {
            setErrorList(errorList.filter((err) => err.field !== "address"));
        }
    }, [popReset, zoneAddress]);
    function onChangeZoneName(e) {
        setErrorList(errorList.filter((err) => err.field !== "zoneName"));
        setZoneName(e.target.value);
    }
    function onClickPostCode(e) {
        setErrorList(errorList.filter((err) => err.field !== "address"));
        setIsPopupPostCode(true);
        CUTIL.jsopen_InteriorPopup(e);
    }
    function ZoneAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/product/zone`,
                appQuery: {
                    companyId: userInfo.role == CONST.USERROLE_ADMIN ? recoilTree.company.companyId : userInfo.companyName,
                    zoneName: zoneName,
                    address: zoneAddress.address,
                    memo: memo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    Close("pop-add-company");
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.등록완료"), callBack: () => {
                            setReloadPages(true);
                            setRecoilTree(Object.assign(Object.assign({}, recoilTree), { zone: { zoneId: data.body.zoneId, zoneName: data.body.zoneName }, subZone: { subZoneId: "", subZoneName: "" }, room: { roomId: "", roomName: "" } }));
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
        });
    }
    function Close(id) {
        setZoneAddress(null);
        setErrorList([]);
        setZoneName("");
        setMemo("");
        setPopRest(false);
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("h2", { children: t("라벨.신규사업장정보") }), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [userInfo.role == CONST.USERROLE_ADMIN && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.회사명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", placeholder: "", value: recoilTree.company.companyName, readOnly: true }) }))] })), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.사업장명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.사업장명입력"), className: `${errorList.filter((err) => err.field === "zoneName").length > 0 ? " input-error" : ""}`, value: zoneName, onChange: (e) => onChangeZoneName(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "zoneName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.사업장주소") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("div", Object.assign({ className: "txt" }, { children: _jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.직접입력"), className: `${errorList.filter((err) => err.field === "address").length > 0 ? " input-error" : ""}`, readOnly: true, value: zoneAddress ? zoneAddress.address : "", "data-pop": "pop-postcode", onFocus: (e) => onClickPostCode(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "address").map((err) => err.msg) })), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })) })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-add-company") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => ZoneAdd(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function SubZoneAddPop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    //props
    const { zoneAddress, setIsPopupPostCode, resetPop, setResetPop, setZoneAddress } = props;
    //
    const [errorList, setErrorList] = useState([]);
    const [subZoneName, setSubZoenName] = useState("");
    const [memo, setMemo] = useState("");
    const [apiBlooean, setApiBlooen] = useState(false);
    useEffect(() => {
        if (resetPop) {
            Close("pop-add-detail");
        }
        if (zoneAddress) {
            setErrorList(errorList.filter((err) => err.field !== "address"));
        }
    }, [resetPop, zoneAddress]);
    function onChangeSubZone(e) {
        setErrorList(errorList.filter((err) => err.field !== "subZoneName"));
        setSubZoenName(e.target.value);
    }
    function SubZoneAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            // if ((zoneAddress && zoneAddress.address) && subZoneName) {
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/product/subzone`,
                appQuery: {
                    zoneId: recoilTree.zone.zoneId,
                    subZoneName: subZoneName,
                    memo: memo,
                    addressDtoIn: {
                        address: zoneAddress ? zoneAddress.address : null,
                        sigunguCd: zoneAddress ? zoneAddress.sigunguCd : null,
                        bjdongCd: zoneAddress ? zoneAddress.bjdongCd : null,
                        bun: zoneAddress ? zoneAddress.bun : null,
                        ji: zoneAddress ? zoneAddress.ji : null,
                        postalCode: zoneAddress ? zoneAddress.postalCode : null,
                        bname: zoneAddress ? zoneAddress.bname : null,
                    },
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    Close("pop-add-detail");
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.상세사업장이등록되었습니다"), callBack: () => {
                            setReloadPages(true);
                            setReload(true);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    if (data.errorList !== null) {
                        setErrorList(data.errorList);
                    }
                    else {
                        Close("pop-add-detail");
                        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: "500 Internal Server Error", callBack: () => {
                                CUTIL.jsclose_Popup(CONST.POP_ALERT);
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
            /*  } else {
               setErrorList([
                 (!subZoneName) && { field: "subZoneName", msg: t("라벨.필수항목을입력하지않으셨습니다") },
                 (!zoneAddress) && { field: "address", msg: t("라벨.필수항목을입력하지않으셨습니다") },
               ])
         
             } */
        });
    }
    function SubZoneAddress(subZoneId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/energyreport/address`,
                appQuery: {
                    address: zoneAddress.address,
                    sigunguCd: zoneAddress.sigunguCd,
                    bjdongCd: zoneAddress.bjdongCd,
                    bun: zoneAddress.bun,
                    ji: zoneAddress.ji,
                    postalCode: zoneAddress.postalCode,
                    bname: zoneAddress.bname,
                    subZoneId: subZoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.상세사업장이등록되었습니다"), callBack: () => {
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                            location.reload();
                        } }));
                    Close("pop-add-detail");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                    /*
                            setReloadPages(true)
                            setReload(true)
                            setAlerts({
                              ...alerts,
                              type: CONST.TYPE_NONE,
                              divTag: t("라벨.상세사업장이등록되었습니다"),
                            });
                            Close("pop-add-detail")
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                            setReload(false)
                            setReloadPages(false)
                            setRecoilIsLoadingBox(false); */
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                    setReloadPages(true);
                    setReload(true);
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.상세사업장의주소를다시입력해주세요") }));
                    Close("pop-add-detail");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadPages(false);
                    setRecoilIsLoadingBox(false);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function onClickPostCode(e) {
        setErrorList(errorList.filter((err) => err.field !== "addressDtoIn"));
        setIsPopupPostCode(true);
        CUTIL.jsopen_InteriorPopup(e);
    }
    /*
    function KeyDowns(e) {
  
        if (memo.length > 0) {
            if (e.key == "Enter") {
                let hashTagTxt = `# ${memo}`
                setHashTag([...hashTag, hashTagTxt])
            }
        }
    }
  
    function KeyUps(e) {
        if (memo.length > 0) {
            if (e.key == "Enter") {
                setMemo("")
            }
        }
    } */
    function Close(id) {
        setErrorList([]);
        setSubZoenName("");
        setMemo("");
        setZoneAddress(null);
        setResetPop(false);
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("ul", Object.assign({ className: "locate" }, { children: _jsx("li", { children: recoilTree.zone.zoneName }) })), _jsx("h2", Object.assign({ className: "mt-32" }, { children: t("라벨.신규상세사업장정보") })), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.명칭") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.상세사업장입력"), className: errorList.filter((err) => err.field === "subZoneName").length > 0 ? "input-error" : "", value: subZoneName, onChange: (e) => onChangeSubZone(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "subZoneName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세사업장주소") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "txt" }, { children: [_jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { className: `js-open ${errorList.filter((err) => err.field === "addressDtoIn").length > 0 ? " input-error" : ""}`, type: "text", style: { background: "#fff" }, placeholder: t("라벨.주소선택"), "data-pop": "pop-postcode", onFocus: (e) => onClickPostCode(e), value: zoneAddress ? zoneAddress.address : "", readOnly: true }), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })), _jsx("p", Object.assign({ className: "input-errortxt", style: {
                                                        display: errorList.filter((err) => err.field === "addressDtoIn").length > 0 ? "block" : "none",
                                                    } }, { children: errorList.filter((err, idx) => err.field === "addressDtoIn" && idx == 0).map((err) => err.msg) }))] })) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => Close("pop-add-detail") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SubZoneAdd(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function RoomAddPop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTree = useRecoilValue(curAdminTreeState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadPages, setReloadPages] = useRecoilState(reLoadPage);
    //props
    const { resetRoomPop, setResetRoomPop } = props;
    //
    const [errorList, setErrorList] = useState([]);
    const [roomName, setRoomName] = useState("");
    const [memo, setMemo] = useState("");
    const [fileT, setFileT] = useState([]);
    const lastNum = 10;
    useEffect(() => {
        if (resetRoomPop) {
            Close("pop-add-detail2");
        }
    }, [resetRoomPop]);
    function onChangeRoom(e) {
        setErrorList(errorList.filter((err) => err.field !== "roomName"));
        setRoomName(e.target.value);
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...fileT];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFileT(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index) {
        setFileT(fileT.filter((_, idx) => idx !== index));
    }
    function RoomAdd(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/product/room`,
                appQuery: {
                    subZoneId: recoilTree.subZone.subZoneId,
                    roomName: roomName,
                    memo: memo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (fileT.length > 0) {
                        uploadFileImage(data.body.roomId);
                    }
                    else {
                        setReloadPages(true);
                        setReload(true);
                        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.분전소가등록되었습니다") }));
                        Close("pop-add-detail2");
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setReloadPages(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    if (data.errorList !== null) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    // 첨부파일 업로드
    function uploadFileImage(roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let appPath = `?roomId=${roomId}`;
            const formData = new FormData();
            // 파일 데이터 저장
            fileT.map((files) => formData.append("files", files));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/room${appPath}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPages(true);
                    setReload(true);
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.분전소가등록되었습니다") }));
                    Close("pop-add-detail2");
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setReloadPages(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setAlerts(Object.assign(Object.assign({}, alerts), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.오류로인하여첨부파일이제거되어분전소만수정되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    function Close(id) {
        setErrorList([]);
        setRoomName("");
        setMemo("");
        setFileT([]);
        setResetRoomPop(false);
        CUTIL.jsclose_Popup(id);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: recoilTree.zone.zoneName }), _jsx("li", { children: recoilTree.subZone.subZoneName }), _jsx("li", { children: t("라벨.전체") })] })), _jsx("h2", Object.assign({ className: "mt-32" }, { children: t("라벨.신규분전소등록") })), _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.명칭") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "text", className: errorList.filter((err) => err.field === "roomName").length > 0 ? "input-error" : "", placeholder: t("라벨.분전소입력"), value: roomName, onChange: (e) => onChangeRoom(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "roomName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.전기실도면") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.클릭등록"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file1" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", id: "file1", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부120MB") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: fileT.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imgsEdit_" + idx.toString()))) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { className: "h74", placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value) }) }))] })] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-add-detail2") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => RoomAdd(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function DeviceAddPop(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const [reload, setReload] = useRecoilState(reLoad);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const langIds = useRecoilValue(langId);
    //props
    const { popreset, setPopreset, onClickTab } = props;
    // useState
    const [spgInfo, setSpgInfo] = useState([]);
    const [spg, setSpg] = useState(null);
    const [elecInfo, setEleInfo] = useState([]);
    const [itemName, setItemName] = useState("");
    const [panelName, setPanelName] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [memo, setMemo] = useState("");
    const [today, setToday] = useState("");
    const [errorList, setErrorList] = useState([]);
    const [file, setFile] = useState([]);
    const [elecCode, setElecCode] = useState(null);
    const lastNum = 10;
    useEffect(() => {
        if (popreset) {
            PopClose("pop-add-info2");
            setPopreset(false);
        }
    }, [popreset]);
    // spg select 후 전력 정보 추출
    function SpgSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/${recoilTree.company.companyId}/spgs`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSpgInfo(data.body);
                }
                else {
                    // need error handle
                }
            }
        });
    }
    // spg select 후 전력 정보 추출
    function onClickSpg(val) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${val.companySpgId}/elecinfos/type`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setEleInfo(data.body.map((item, idx) => (Object.assign(Object.assign({}, item), { value: item.type < 2 ? "" : langIds < 2 ? item.unit[0] : item.unitEn[0], idx: idx, 
                        // uiType: item.type,
                        unit: item.type < 2
                            ? item.unit
                            : item.unit.map((value, index) => ({
                                name: value,
                                selected: false,
                                id: idx,
                                unitId: value[0] + index,
                            })), unitEn: item.type < 2
                            ? item.unitEn
                            : item.unitEn.map((value, index) => ({
                                name: value,
                                selected: false,
                                id: idx,
                                unitEnId: value[0] + index,
                            })), checked: false }))));
                    setSpg(val);
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    // elecInfo type2
    function onClickElecInfo(item, list, id, unitId, blooean) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${spg.companySpgId}/elecinfos/type`,
                appQuery: {
                    name: list.name,
                    elecCode: item.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    let itemArr = elecInfo.map((smenu) => smenu.code === item.code
                        ? Object.assign(Object.assign({}, smenu), { checked: true, value: list.name, unit: smenu.type < 2
                                ? smenu.unit
                                : smenu.unit.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { selected: item.unitId == unitId ? true : false }) : item), unitEn: smenu.type < 2
                                ? smenu.unitEn
                                : smenu.unitEn.map((item) => item.id === id ? Object.assign(Object.assign({}, item), { selected: item.unitId == unitId ? true : false }) : item) }) : smenu);
                    const selcetItem = data.body.map((item) => (Object.assign(Object.assign({}, item), { value: "", 
                        // uiType: 3,
                        id: id })));
                    const listArr = itemArr.concat(selcetItem).sort((a, b) => (a.sort > b.sort ? 1 : -1));
                    const elecInfoListArr = (data) => {
                        const uniqueItems = new Set();
                        return data.filter((item) => {
                            const itemString = JSON.stringify(item);
                            if (uniqueItems.has(itemString)) {
                                return false;
                            }
                            else {
                                uniqueItems.add(itemString);
                                return true;
                            }
                        });
                    };
                    // 중복 제거된 데이터
                    const uniqueData = elecInfoListArr(listArr);
                    if (blooean) {
                        const dataArr = uniqueData.filter((item) => item.id !== id);
                        const changeData = dataArr.concat(selcetItem).sort((a, b) => (a.sort > b.sort ? 1 : -1));
                        setEleInfo(changeData);
                    }
                    else {
                        setEleInfo(uniqueData);
                    }
                }
                else {
                    setErrorList(errorList.filter((err) => err.field !== "elecinfos"));
                }
            }
        });
    }
    function PopClose(id) {
        CUTIL.IdScrollIntoView(id, "form__input");
        setSpg(null);
        setItemName("");
        setPanelName("");
        setSerialNo("");
        setManufacturer("");
        setMemo("");
        setToday("");
        setEleInfo([]);
        setFile([]);
        CUTIL.jsclose_Popup(id);
    }
    // 전력정보 등록
    function ElecIfoChange(e, id) {
        setEleInfo(elecInfo.map((smenu) => (smenu.companyElecId === id ? Object.assign(Object.assign({}, smenu), { value: e.target.value }) : smenu)));
    }
    function onChangeItem(e) {
        setErrorList(errorList.filter((err) => err.field !== "itemName"));
        setItemName(e.target.value);
    }
    function onChangePanel(e) {
        setErrorList(errorList.filter((err) => err.field !== "panelName"));
        setPanelName(e.target.value);
    }
    function onChangeSerialNo(e) {
        setErrorList(errorList.filter((err) => err.field !== "serialNo"));
        setSerialNo(e.target.value);
    }
    function onChangeManufacturer(e) {
        setErrorList(errorList.filter((err) => err.field !== "manufacturer"));
        setManufacturer(e.target.value);
    }
    function onChangeTodayMonth(e) {
        setErrorList(errorList.filter((err) => err.field !== "madeyyyyMM"));
        if (e.target.value.length <= 7) {
            setToday(e.target.value);
        }
    }
    function itemAddClick(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            let itemArr = [];
            for (let i = 0; i < elecInfo.length; i++) {
                itemArr.push({
                    elecCode: elecInfo[i].code,
                    value: elecInfo[i].value,
                });
            }
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/product/item`,
                appQuery: {
                    roomId: recoilTree.room.roomId,
                    spgName: spg ? spg.spgName : "",
                    itemName: itemName,
                    panelName: panelName,
                    serialNo: serialNo,
                    manufacturer: manufacturer,
                    madeyyyyMM: dayjs(today).format("YYYYMM").toString(),
                    elecInfo: itemArr,
                    memo: memo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (file.length > 0) {
                        uploadFileImage(data.body.itemIdPk);
                    }
                    else {
                        setReload(true);
                        PopClose("pop-add-info2");
                        setAlerts(Object.assign(Object.assign({}, alerts), { layerId: "pop-add-info2", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가등록되었습니다") }));
                        onClickTab("DEVICE");
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-info2");
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                }
                else {
                    // need error handle
                    setErrorList(data.errorList);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files;
            let imageUpload = [...file];
            for (let i = 0; i < files.length; i++) {
                //  미리보기 구현시 필요 URL.createObjectURL(file[i]);
                imageUpload.push(files[i]);
            }
            if (imageUpload.length > lastNum) {
                imageUpload = imageUpload.slice(0, 10);
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: "첨부파일은 10개 까지 가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            setFile(imageUpload);
            e.target.value = ""; // file name 초기화
        });
    }
    // 이미지 삭제
    function onClickAttachFileDelete(index) {
        setFile(file.filter((_, idx) => idx !== index));
    }
    // 첨부파일 업로드
    function uploadFileImage(itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let appPath = `?itemId=${itemId}`;
            const formData = new FormData();
            // 파일 데이터 저장
            file.map((files) => formData.append("files", files));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POSTF",
                appPath: `/images/item${appPath}`,
                appQuery: formData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setFile([]);
                    setReload(true);
                    PopClose("pop-add-info2");
                    setAlerts(Object.assign(Object.assign({}, alerts), { layerId: "pop-add-info2", type: CONST.TYPE_INNRE, divTag: t("라벨.기기가등록되었습니다") }));
                    CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-add-info2");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    if (data.errorList) {
                        setErrorList(data.errorList);
                        setRecoilIsLoadingBox(false);
                    }
                    else {
                        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function AddClose(id) {
        CUTIL.jsclose_Popup(id);
        // setCheckEdit(null);
        // setCheckChange(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body pb-0" }, { children: [_jsxs("ul", Object.assign({ className: "locate" }, { children: [_jsx("li", { children: recoilTree.company.companyName + " " + recoilTree.zone.zoneName }), _jsx("li", { children: recoilTree.subZone.subZoneName }), _jsx("li", { children: t("라벨.전체") })] })), _jsxs("div", Object.assign({ className: "mt-32" }, { children: [_jsx("h2", { children: t("라벨.설비정보") }), !popreset && (_jsxs("ul", Object.assign({ className: "form__input scrollH h440 pb-30" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.분전소명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp26", value: recoilTree.room.roomName, readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select spg ${errorList.filter((err) => err.field === "companyId").length > 0 ? " input-error" : ""}`, onClick: (e) => SpgSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !spg ? t("라벨.클릭선택") : spg.spgName })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSpg(info) }, { children: info.spgName }), "spgInfos_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.형명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { className: `${errorList.filter((err) => err.field === "itemName").length > 0 ? " input-error" : ""}`, type: "text", id: "inp22", placeholder: t("라벨.텍스트입력"), value: itemName, onChange: (e) => onChangeItem(e) }) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "itemName").map((err) => err.msg) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.판넬명") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "panelName").length > 0 ? " input-error" : ""}`, type: "text", id: "inp23", placeholder: t("라벨.텍스트입력"), value: panelName, onChange: (e) => onChangePanel(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "panelName").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.시리얼번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "serialNo").length > 0 ? " input-error" : ""}`, type: "text", id: "inp24", placeholder: t("라벨.텍스트입력"), value: serialNo, onChange: (e) => onChangeSerialNo(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "serialNo").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.제조사") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "manufacturer").length > 0 ? " input-error" : ""}`, type: "text", id: "inp25", placeholder: t("라벨.텍스트입력"), value: manufacturer, onChange: (e) => onChangeManufacturer(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "manufacturer").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.제조년월") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { className: `${errorList.filter((err) => err.field === "madeyyyyMM").length > 0 ? " input-error" : ""}`, type: "text", id: "inp28", placeholder: t("라벨.제조년월입력"), value: today, onChange: (e) => onChangeTodayMonth(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "madeyyyyMM").map((err) => err.msg) }))] }))] }), elecInfo.map((item, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: `tit mt-0` }, { children: [langIds > 1 ? item.elecInfoNameEnglish : item.elecInfoName, " ", item.type < 2 && `(${item.unit})`, _jsx("br", {}), _jsxs("span", Object.assign({ className: "fontRegular" }, { children: ["(", item.code, ")"] }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: item.type < 2 ? (_jsx("input", { type: "text", id: "inp_" + idx, value: item.value, onChange: (e) => ElecIfoChange(e, item.companyElecId) })) : (
                                                // {(errorList.filter(err => (err.field === "companyId")).length > 0) ? " input-error" : ""}
                                                _jsxs("div", Object.assign({ className: `select elecinfo_${idx} $`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: t("라벨.클릭선택") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: langIds > 1
                                                                ? item.unitEn.map((list, index) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickElecInfo(item, list, item.idx, list.unitId, item.checked) }, { children: list.name }), "unitEn_" + index.toString())))
                                                                : item.unit.map((list, index) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickElecInfo(item, list, item.idx, list.unitId, item.checked) }, { children: list.name }), "unit_" + index.toString()))) })] }))) }))] }, "lsinfoEdit_" + idx.toString()))), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: _jsx("span", { children: t("라벨.첨부파일") }) })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "filebox" }, { children: [_jsx("input", { className: "upload-name", value: "", placeholder: t("라벨.사진첨부하세요"), readOnly: true }), _jsx("label", Object.assign({ htmlFor: "file8" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD30C\uC77C\uCC3E\uAE30" })) })), _jsx("input", { type: "file", accept: "image/*", id: "file8", multiple: true, onChange: (e) => saveFileImage(e) })] })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("라벨.첨부120MB") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: file.map((img, idx) => (_jsxs("li", { children: [_jsx("span", { children: img.name }), _jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }, "imgsEdit_" + idx.toString()))) }))] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { placeholder: t("라벨.텍스트입력"), value: memo, onChange: (e) => setMemo(e.target.value), onKeyDown: (e) => CUTIL.beforeHandleComment(e, 400), onKeyUp: (e) => CUTIL.afterHandleComment(e, 400, setMemo) }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [memo ? memo.length : "0", " / 400"] }))] }))] })] })))] }))] })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => PopClose("pop-add-info2") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => itemAddClick(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
